import { useState } from 'react'
import { Button, Form } from 'react-bootstrap'

import { useApprovePackageRequest, useRejectPkgReq } from '../../../../api/package-req'

export const ShrinkRequestDetails = ({ item, onApprove, onBack }) => {
  const approvePackageRequestMutation = useApprovePackageRequest()
  const rejectPackageRequestMutation = useRejectPkgReq()
  const [height, setHeight] = useState('')
  const [heightUSA, setHeightUSA] = useState('')
  const [weight, setWeight] = useState('')
  const [weightUSA, setWeightUSA] = useState('')
  const [width, setWidth] = useState('')
  const [widthUSA, setWidthUSA] = useState('')
  const [length, setLength] = useState('')
  const [lengthUSA, setLengthUSA] = useState('')

  const resetState = async () => {
    //reset states
    setHeight('')
    setHeightUSA('')
    setWeight('')
    setWeightUSA('')
    setWidth('')
    setWidthUSA('')
    setLength('')
    setLengthUSA('')
  }

  const approveReq = async () => {
    try {
      //approve package req
      const dataForApprove = {
        packageReqId: item.id,
        newDimensions: {
          weight,
          height,
          width,
          length,
        },
      }
      const res = await approvePackageRequestMutation.mutateAsync(dataForApprove)
      if (res.statusCode !== 200) {
        const message = res.msg || 'Error approving shrink request'
        alert(message)
        return
      }
      // console.log('approveReq - approveResult:', approveResult)
      resetState()
      onApprove()
    } catch (error) {
      console.log('approveReq - error:', error)
      alert('Error Approving Request!', error)
    }
    resetState()
  }

  const twoDecimals = num => {
    return Math.floor(num * 100) / 100
  }

  const onCancelShrinkRequest = async rejectReason => {
    const isConfirmed = window.confirm('Are you sure you want to cancel shrink request?')
    if (!isConfirmed) return

    try {
      const data = {
        reqType: 'shrinkRequest',
        packageId: item.packageId,
        packageReqId: item.id,
        rejectReason,
        costumerEmail: item.costumerEmail,
      }

      const res = await rejectPackageRequestMutation.mutateAsync(data)
      if (res.statusCode !== 200) {
        const message = res.msg || 'Error rejecting shrink request'
        alert(message)
        return
      }
      onBack()
      // console.log(" onCancelShrinkRequest - res:", res)
    } catch (error) {
      console.log('Error while trying to cancel shrink request', error)
    } finally {
      resetState()
    }
  }

  return (
    <div className='req-form-cont'>
      <div className='d-flex justify-content-between align-items-center'>
        <h2>Shrink Package</h2>
        <Button variant='danger' size='sm' className='btn-icon ml-4' onClick={onBack}>
          X
        </Button>
      </div>
      <div className='pr-shrinkl-notes'>
        <h4>Notes:</h4>
        <div>{item.shrinkNotes}</div>
      </div>

      <div className='pr-shrink-form'>
        <Form.Group controlId='exampleForm.ControlInput2'>
          {item.warehouse !== 'USA' ? (
            <>
              <Form.Label>Height</Form.Label>
              <Form.Control
                onChange={e => {
                  setHeight(parseFloat(e.target.value))
                }}
                name='height'
                type='text'
                value={height}
              />
            </>
          ) : (
            <>
              <Form.Label>Height (INCH)</Form.Label>
              <Form.Control
                onChange={e => {
                  setHeight(e.target.value !== '' ? Math.round(parseFloat(e.target.value) * 2.54) : 0)
                  setHeightUSA(e.target.value)
                }}
                name='height'
                type='text'
                value={heightUSA}
              />

              <Form.Label>Height (CM)</Form.Label>
              <Form.Control name='height' type='text' value={height} disabled />
            </>
          )}
        </Form.Group>

        <Form.Group controlId='exampleForm.ControlInput3'>
          {item.warehouse !== 'USA' ? (
            <>
              <Form.Label>Width</Form.Label>
              <Form.Control
                onChange={e => {
                  setWidth(parseFloat(e.target.value))
                }}
                name='width'
                type='text'
                value={width}
              />
            </>
          ) : (
            <>
              <Form.Label>Width (INCH)</Form.Label>
              <Form.Control
                onChange={e => {
                  setWidth(e.target.value !== '' ? Math.round(parseFloat(e.target.value) * 2.54) : 0)
                  setWidthUSA(e.target.value)
                }}
                name='width'
                type='text'
                value={widthUSA}
              />

              <Form.Label>Width (CM)</Form.Label>
              <Form.Control name='width' type='text' value={width} disabled />
            </>
          )}
        </Form.Group>

        <Form.Group controlId='exampleForm.ControlInput4'>
          {item.warehouse !== 'USA' ? (
            <>
              <Form.Label>Length</Form.Label>
              <Form.Control
                onChange={e => {
                  setLength(parseFloat(e.target.value))
                }}
                name='length'
                type='text'
                value={length}
              />
            </>
          ) : (
            <>
              <Form.Label>Length (INCH)</Form.Label>
              <Form.Control
                onChange={e => {
                  setLength(e.target.value !== '' ? Math.round(parseFloat(e.target.value) * 2.54) : 0)
                  setLengthUSA(e.target.value)
                }}
                name='length'
                type='text'
                value={lengthUSA}
              />

              <Form.Label>Length (CM)</Form.Label>
              <Form.Control name='length' type='text' value={length} disabled />
            </>
          )}
        </Form.Group>

        <Form.Group controlId='exampleForm.ControlInput5'>
          {item.warehouse !== 'USA' ? (
            <>
              <Form.Label>Weight</Form.Label>
              <Form.Control
                onChange={e => {
                  setWeight(parseFloat(e.target.value))
                }}
                name='weight'
                type='text'
                value={weight}
              />
            </>
          ) : (
            <>
              <Form.Label>Weight (Pound)</Form.Label>
              <Form.Control
                onChange={e => {
                  setWeight(e.target.value !== '' ? twoDecimals(parseFloat(e.target.value) * 0.4535923) : 0)
                  setWeightUSA(e.target.value)
                }}
                name='weight'
                type='text'
                value={weightUSA}
              />

              <Form.Label>Weight (KG)</Form.Label>
              <Form.Control name='weight' type='text' value={weight} disabled />
            </>
          )}
        </Form.Group>
      </div>

      <Button variant='primary' onClick={approveReq} disabled={!height || !width || !length || !weight}>
        Approve
      </Button>
      <div className='reject-reqs-cont'>
        <h4>Reject Request</h4>

        <div className='reject-req-cards-cont'>
          <div className='reject-req-card'>
            <div style={{ fontWeight: 'bold' }}>Fragile Package</div>
            <div>Cant shrink package because the item is too fragile.</div>
            <Button variant='danger' style={{ backgroundColor: 'red' }} onClick={() => onCancelShrinkRequest('fragile')}>
              Reject
            </Button>
          </div>
          <div className='reject-req-card'>
            <div style={{ fontWeight: 'bold' }}>Small Package</div>
            <div>The package is small as possible.</div>
            <Button variant='danger' style={{ backgroundColor: 'red' }} onClick={() => onCancelShrinkRequest('tooSmall')}>
              Reject
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
